
import { useState } from 'react';

export default function Restaurant() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const dishes = [
    {
      name: 'Planches Charcuterie & Fromages',
      description: 'Nos planches généreuses avec charcuterie fine, fromages sélectionnés et tapenades maison. Des planches variées pour tous les goûts, à partager entre amis ou en famille.',
      menu: [
        'Planches de charcuterie',
        'Planches de fromages',
        'Fromages rôtis',
        'Pizzas et/ou plats selon le menu de la semaine'
      ],
      image: 'https://static.readdy.ai/image/d4c222fca79cec1b33ab7f1e22d0ce93/e621913598177410df4b5ffa6ec95622.png',
      badge: '🧀 Spécialité',
      badgeColor: 'bg-[#4A7C59]'
    },
    {
      name: 'Bar Complet & Cocktails',
      description: 'Cocktails tropicaux, spiritueux et boissons variées grâce à notre Licence 4. Profitez d\'un bar complet dans une ambiance chaleureuse et festive.',
      image: 'https://static.readdy.ai/image/d4c222fca79cec1b33ab7f1e22d0ce93/4bf52746f23a36464e60942bff7c249d.png',
      badge: '🍹 Licence 4',
      badgeColor: 'bg-[#FF8F6B]'
    },
    {
      name: 'Ambiance Tropicale',
      description: 'Un cadre unique et chaleureux pour vos moments de détente. Tapas & plats à partager dans une atmosphère tropicale inoubliable.',
      image: 'https://readdy.ai/api/search-image?query=tropical%20restaurant%20terrace%20warm%20ambient%20lighting%20lush%20green%20plants%20wooden%20tables%20cozy%20evening%20atmosphere%20with%20string%20lights%20and%20palm%20trees%20warm%20tones%20inviting%20outdoor%20dining%20space&width=800&height=600&seq=tropicale1&orientation=landscape',
      badge: '🌴 Ambiance',
      badgeColor: 'bg-[#F5E6D3] !text-[#4A7C59]'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % dishes.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + dishes.length) % dishes.length);
  };

  return (
    <section id="restaurant" className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-br from-white via-[#F5E6D3]/20 to-white relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute top-10 left-4 md:left-10 text-6xl md:text-9xl opacity-10 animate-float">🍽️</div>
      <div className="absolute bottom-10 right-4 md:right-10 text-6xl md:text-9xl opacity-10 animate-float" style={{ animationDelay: '1s' }}>🥗</div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Title */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-block bg-[#4A7C59] text-white px-4 md:px-8 py-2 md:py-3 rounded-full text-xs md:text-sm font-bold mb-4 md:mb-6 whitespace-nowrap">
            RESTAURANT & TAPAS 🍴
          </div>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-black text-[#4A7C59] mb-4 md:mb-6 px-4" style={{ fontFamily: 'Pacifico, cursive' }}>
            Des saveurs qui <span className="text-gradient-animated">réveillent</span>
          </h2>
          
          <p className="text-lg md:text-2xl text-gray-600 font-semibold px-4 mb-2">
            Tapas & plats à partager dans une ambiance tropicale 🌴
          </p>
          <p className="text-base md:text-lg text-[#FF8F6B] font-bold px-4">
            ✨ Licence 4 - Bar complet avec spiritueux
          </p>
        </div>

        {/* Carousel */}
        <div className="mb-12 md:mb-16">
          <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden relative">
            <div className="grid md:grid-cols-2 gap-0">
              {/* Image Side */}
              <div className="relative h-64 sm:h-80 md:h-[420px]">
                <img 
                  src={dishes[currentSlide].image}
                  alt={dishes[currentSlide].name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content Side */}
              <div className="p-6 md:p-8 lg:p-12 flex flex-col justify-center">
                <div className="mb-6">
                  <span className={`inline-block px-3 md:px-4 py-1.5 md:py-2 ${dishes[currentSlide].badgeColor} text-white rounded-full text-xs md:text-sm font-bold mb-3 md:mb-4 whitespace-nowrap`}>
                    {dishes[currentSlide].badge}
                  </span>
                  <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#4A7C59] mb-3 md:mb-4" style={{ fontFamily: 'Pacifico, cursive' }}>
                    {dishes[currentSlide].name}
                  </h3>
                  <p className="text-gray-600 text-sm md:text-base lg:text-lg leading-relaxed mb-4">
                    {dishes[currentSlide].description}
                  </p>
                  
                  {/* Menu list for first slide */}
                  {dishes[currentSlide].menu && (
                    <div className="bg-[#F5E6D3]/50 rounded-xl p-4 mt-4">
                      <p className="font-bold text-[#4A7C59] mb-3 text-sm md:text-base">Au menu, le soir :</p>
                      <ul className="space-y-2">
                        {dishes[currentSlide].menu.map((item, index) => (
                          <li key={index} className="flex items-start gap-2 text-gray-700 text-sm md:text-base">
                            <span className="text-[#4A7C59] font-bold">•</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Navigation Arrows */}
            <>
              <button
                onClick={prevSlide}
                className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 cursor-pointer z-10"
                aria-label="Image précédente"
              >
                <i className="ri-arrow-left-s-line text-xl md:text-2xl text-[#4A7C59]"></i>
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 cursor-pointer z-10"
                aria-label="Image suivante"
              >
                <i className="ri-arrow-right-s-line text-xl md:text-2xl text-[#4A7C59]"></i>
              </button>

              {/* Dots Indicator */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
                {dishes.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all cursor-pointer ${
                      index === currentSlide ? 'bg-[#4A7C59] w-6 md:w-8' : 'bg-white/60'
                    }`}
                    aria-label={`Aller à l'image ${index + 1}`}
                  />
                ))}
              </div>
            </>
          </div>
        </div>

        {/* Opening Hours for Bar & Tapas */}
        <div className="bg-gradient-to-br from-[#4A7C59] to-[#3d6849] rounded-2xl md:rounded-3xl p-6 md:p-10 text-white text-center shadow-2xl">
          <h3 className="text-2xl md:text-3xl font-bold mb-6" style={{ fontFamily: 'Pacifico, cursive' }}>
            🍹 Horaires Bar & Tapas
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-5">
              <p className="font-bold text-lg md:text-xl mb-2">Jeudi, Dimanche, Lundi</p>
              <p className="text-2xl md:text-3xl font-black">17h30 - 22h</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-5">
              <p className="font-bold text-lg md:text-xl mb-2">Vendredi & Samedi</p>
              <p className="text-2xl md:text-3xl font-black">17h30 - 23h</p>
            </div>
          </div>
          <p className="mt-6 text-white/90 text-sm md:text-base">
            Réservation recommandée • Planches à partager • Cocktails maison
          </p>
        </div>
      </div>
    </section>
  );
}
